// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__17MW8","inputDescription":"styles_inputDescription__1plTE"};